import React from 'react';
import './FilterBar.css';

export interface FilterBarProps {
    selectedBook: string;
    selectedChapter: string;
    selectedQuestionType: 'true_false' | 'multiple_choice';
    availableBooks: string[];
    availableChapters: string[];
    trueFalseCount: number;
    multipleChoiceCount: number;
    onBookChange: (bookId: string) => void;
    onChapterChange: (chapterId: string) => void;
    onQuestionTypeChange: (questionType: 'true_false' | 'multiple_choice') => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
    selectedBook,
    selectedChapter,
    selectedQuestionType,
    availableBooks,
    availableChapters,
    trueFalseCount,
    multipleChoiceCount,
    onBookChange,
    onChapterChange,
    onQuestionTypeChange
}) => {
    return (
        <div className="content-filters">
            <div className="content-filter-group">
                <label htmlFor="book-select" className="content-filter-label">Book:</label>
                <select
                    id="book-select"
                    value={selectedBook}
                    onChange={(e) => onBookChange(e.target.value)}
                    className="content-filter-select"
                >
                    {availableBooks.map(bookId => (
                        <option key={bookId} value={bookId}>
                            {bookId}
                        </option>
                    ))}
                </select>
            </div>

            <div className="content-filter-group">
                <label htmlFor="chapter-select" className="content-filter-label">Chapter:</label>
                <select
                    id="chapter-select"
                    value={selectedChapter}
                    onChange={(e) => onChapterChange(e.target.value)}
                    className="content-filter-select"
                >
                    <option value="all">All Chapters</option>
                    {availableChapters.map(chapterId => (
                        <option key={chapterId} value={chapterId}>
                            Chapter {chapterId}
                        </option>
                    ))}
                </select>
            </div>

            <div className="content-filter-group">
                <label htmlFor="question-type-select" className="content-filter-label">Question Type:</label>
                <select
                    id="question-type-select"
                    value={selectedQuestionType}
                    onChange={(e) => onQuestionTypeChange(e.target.value as 'true_false' | 'multiple_choice')}
                    className="content-filter-select"
                >
                    <option value="true_false">True/False</option>
                    <option value="multiple_choice">Multiple Choice</option>
                </select>
            </div>

            <div className="content-filter-stats">
                <div className="content-stat">
                    <span className="content-stat-number primary medium">{trueFalseCount}</span>
                    <span className="content-stat-label">{trueFalseCount === 1 ? 'True/False' : 'True/False'}</span>
                </div>
                <div className="content-stat">
                    <span className="content-stat-number primary medium">{multipleChoiceCount}</span>
                    <span className="content-stat-label">{multipleChoiceCount === 1 ? 'Multiple Choice' : 'Multiple Choice'}</span>
                </div>
            </div>
        </div>
    );
};

export default FilterBar; 